module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zn":{"revenueDate":"查询日期（UTC）"},"en":{"revenueDate":"Date（UTC）"}}')
  delete Component.options._Ctor
}
